import {
  BillingZoneParams,
  GERMANY_COUNTRY_EXCEPTION,
  LinksAgreementsType,
  USER_AGREEMENTS_LINKS,
} from '../config';

export const getLinksAgreementsByBillingZone = ({
  billingZone,
  country,
}: BillingZoneParams): LinksAgreementsType => {
  if (country !== undefined && GERMANY_COUNTRY_EXCEPTION.includes(country)) {
    return {
      termsAndConditions: USER_AGREEMENTS_LINKS.termsAndConditions,
      dataProcessingAddendum:
        USER_AGREEMENTS_LINKS.dataProcessingAddendumInGermany,
      privacyPolicy: USER_AGREEMENTS_LINKS.privacyPolicyInGermany,
      agreementOffer: '',
      personalDataProcessing: '',
    };
  }

  if (billingZone === 'CIS') {
    return {
      agreementOffer: USER_AGREEMENTS_LINKS.agreementOfferInRussian,
      personalDataProcessing:
        USER_AGREEMENTS_LINKS.personalDataProcessingInRussian,
      termsAndConditions: '',
      dataProcessingAddendum: '',
      privacyPolicy: '',
    };
  }

  // default
  return {
    termsAndConditions: USER_AGREEMENTS_LINKS.termsAndConditions,
    dataProcessingAddendum:
      USER_AGREEMENTS_LINKS.dataProcessingAddendumInEnglish,
    privacyPolicy: USER_AGREEMENTS_LINKS.privacyPolicyInEnglish,
    agreementOffer: '',
    personalDataProcessing: '',
  };
};
